<template>
  <div class="footerseo">
 
  
    <b-container fluid  >
		<b-row>
		<b-col>
			<div class="desktop-popularSearch" ><div >
			<hr data-reactid="122"><div class="desktop-pSearchTitle" > POPULAR SEARCHES </div>
			<div class="desktop-pSearchlinks" >
			<a href="/cosmetics" target="_blank" >Makeup</a>
			<a href="/women" target="_blank">Dresses For Girls</a>
			<a href="/men-t-shirts" target="_blank">T-Shirts</a>
			<a href="/women-sandals" target="_blank">Sandals</a>			
			<a href="/jumpsuits" target="_blank">Babydolls</a>
			<a href="/men-jackets" target="_blank">Blazers For Men</a>
			<a href="/handbags-clutches" target="_blank">Handbags</a>
			<a href="/women-watches" target="_blank">Ladies Watches</a>
			<a href="/bags-belts-wallets" target="_blank">Bags</a>				
			<a href="/men-nightdress-innerwear" target="_blank">Boxers</a>			
			<a href="/women-accessories" target="_blank">Wallets</a>
			<a href="/kurtis-tops" target="_blank">Tops</a>			
			<a href="/women-jewellery" target="_blank">Earrings</a>		
			<a href="/kurtas-suits" target="_blank">Kurtis</a>
			<a href="/women-briefs" target="_blank">Designer Blouse</a>
			<a href="/gowns-dresses" target="_blank">Gowns</a>
			<a href="/women-accessories" target="_blank">Rings</a>
			<a href="/men-formal-shoes" target="_blank">Man Shoes</a>
			<a href="/eyes" target="_blank">Eye Makeup</a>
			<a href="/home-decor" target="_blank">Bedsheet</a>
			<a href="/arts-and-crafts" target="_blank">Handicrafts</a>
			<a href="/books" target="_blank">Books</a>
			
			<a href="/lehenga-choli" target="_blank">Lehenga</a>
			<a href="/Lipstick" target="_blank">Lipstick</a>
			<a href="/sarees" target="_blank">Saree</a>
			<a href="/dupatta-shawls" target="_blank">Dupatta</a>
			<a href="/women-western-wear" target="_blank">Dresses</a>
			<a href="/women-western-wear" target="_blank">Suit</a>
			<a href="/chinos" target="_blank">Chinos</a>
			<a href="/women-accessories" target="_blank">Jewellery</a>			
			<a href="/nails" target="_blank">Nail Paint</a>
			<a href="/men-sportswear" target="_blank">Sport Shoes</a>
			<a href="/lehenga-choli" target="_blank">Punjabi Suits</a>	
			<a href="/brand/newu" target="_blank">newU</a>
			<a href="/brand/disguise" target="_blank">disguise</a>
			<a href="/brand/D-N-Creation" target="_blank">D N Creation</a>
			<a href="/brand/embark" target="_blank">Embark</a>
			<a href="/brand/badahair-products" target="_blank">Badahair Products</a>
			<a href="/brand/clog-london" target="_blank">Clog London</a>
			<a href="/brand/jaquline-usa" target="_blank">Jaquline USA</a>
					
			
			</div>
			</div></div>
		</b-col>
		</b-row>
		<b-row class="mt-2">
		<b-col>
		<hr data-reactid="122">
		<h4>Alluraa – The Social eCommerce Platform led by Influencers</h4>
		<p class="contentText">If anyone would like to experience the best of online shopping for men and women in India, Alluraa is the right place. Alluraa is the ideal source for fashion and lifestyle, hosting a wide array of merchandise including apparels, footwear, accessories, cosmetics, organic products, jewellery, personal care products and more. Our online store brings you the latest in designer clothing and varieties with great discounts. You can shop online at Alluraa in just a few clicks sitting anywhere</p>
		</b-col>
		</b-row>
		
		<b-row class="mt-2">
		
		<b-col>
		<h4>One-stop Shopping Site in India</h4>
		<p class="contentText">Be it apparels, cosmetics, footwear or accessories, Alluraa offers you the ultimate combination of fashion and utility for men & women. You will wonder about discovering unlimited collections and designs in clothing.</p>
		<ul>
			<li><b-link href="/women" target="_blank">Fashionable women’s clothing</b-link> - Online shopping for women at Alluraa is an unmatched experience. Look casual in an embroidered top for women or look trendy on your smart party dress. Designer kurtis with jeans make the perfect combination for the cool people. Our splendid collections of sarees and lehenga-choli are perfect to make an impression at big occasions such as weddings, family parties or festivals.</li>
			<li>
				     <b-link href="/men" target="_blank">Smart men’s clothing </b-link>- At Alluraa you will find innumerable options in smart formal shirts, cool T-shirts and accessories. If you need a fresh look for a special occasion, opt for a stylish layered look with ethnic Jaipuri half sleeve jackets. Browse through our men’s accessories section to find an amazing collection of wallets, bags and belts.

			</li>
			<li>
				    <b-link href="/women-footwear" target="_blank">Fashionable footwear</b-link> – Fashion is incomplete without a right pair of footwear expressing your personality. Alluraa brings you an array of options in formal shoes for men as well as women. You can step into the casual style and comfort offered by sandals, chappal and flip-flops. Explore our latest collection of shoes today.

			</li>
			<li>
				     <b-link href="/trending-products" target="_blank">Trendy accessories </b-link>- Alluraa is one of the best online shopping sites for stylish accessories that perfectly complement your outfits. You can select smart clutches or a set of crafted jewellery matched with your favorite dress. Check our online jewellery collection offering you many exciting options.


			</li>
			<li>
				     <b-link href="/organic" target="_blank">Nurture your beauty </b-link>- You can also refresh, revitalize and reveal beautiful skin with personal care, beauty and grooming products from Alluraa. Our bath and body care products, skin care creams, lotions and other organic products are specially formulated to take care of skin. Keep your scalp clean and your hair with herbal shampoos and serum.


			</li><li>
				     <b-link href="/cosmetics" target="_blank">Perfect cosmetics touch </b-link>- Makeup products are aplenty here on Alluraa with the best quality products from the best brands online. To look stunning, all you need to pick the right combination of makeup products from foundation to a beautiful shade of nail polish and lipstick. There is no dearth of products like concealers, highlighters, eyeliners, mascaras, lip glosses and more. Explore more makeup products on Alluraa today.



			</li>
			
			
			
		</ul>
		</b-col>
		</b-row>
		
		
   </b-container>
			
  </div>
  
</template>

<script>

export default {
  name: 'HelloWorld',
  components: {
    
	},
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
    }
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /*  .footer .footer-top{
     max-width: 90% !important;     
    margin-left: 10% !important;
    }
    .footerLinkul{
     padding: 0px !important;
    }
.footerLinkul li {
    display: block;
    margin: 0 0px !important;
    line-height: 24px;
    font-size: 0.9rem !important;
    text-align: left;
}*/

	.mpp{
		color: #ffffff !important;
		font-size: 13px;
	}
	.ppb{
		  border-right: 1px solid #c6c6c6;
	}
	
	
	.footerList li{ 
		padding: 0 5px 0 10px;
	}
	.footerseo{
	max-width: 80% !important;
    margin-left: 10% !important;
		margin-top: 29px;
		h4{
		font-size: 15px;
		color: #535766;
		}
		.contentText{
			    font-size: 14px;
				color: #94969f;
				line-height: 19px;
		}
		li{
				font-size: 14px;
				color: #94969f;
				line-height: 19px;
				padding-top: 10px;
				list-style-type: auto;
		}


			.desktop-popularSearch hr {
			border: 1px;
			height: 1px;
			background-color: #eaeaec;
			}
			.desktop-pSearchTitle {
				position: absolute;
				margin-top: -24px;
				background: #f9f9f9;
				padding-right: 10px;
				color: #282c3f;
				font-size: 12px;
				font-weight: 500;
			}
			.desktop-pSearchlinks {
			margin-top: 2px;
			
			}
		.desktop-pSearchlinks>a {
		text-decoration: none;
		color: #696b79;
		font-size: 14px;
		line-height: 25px;
		}
		.desktop-pSearchlinks>a:after {
			content: "|";
			margin-left: 3px;
			margin-right: 3px;
		}
		.desktop-pSearchlinks>a:last-child:after {
			content: "";
		}
		
		
		
	}
	@media only screen and (max-width:640px) {
		.footerseo{
					.desktop-pSearchlinks {
					margin-top: 2px;
					overflow: scroll;
					}
				
			}
		
		}


</style>
